var portfolioPositionsList = {
	caption: "Portfolio positions",
	name: "Name",
	isin: "ISIN",
	numberOfShares: "Quantity/Nominal",
	price: "Last price",
	dateTime: "Time/Date",
	todayChange: "Today chg.",
	unrealizedPerformance: "Unrealized perf.",
	marketValue: "Market value",
	purchaseValue: "Purchase value",
	weight: "Weight %",
	actions: "Actions",
	noPositions: "No Positions.",
	averagePurchasePrice: "Avg. buy price"
};
var en = {
	portfolioPositionsList: portfolioPositionsList
};

export { en as default, portfolioPositionsList };
